/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

import BulmaContainer from 'react-bulma-components/lib/components/container';
import BulmaSection from 'react-bulma-components/lib/components/section';

import { linkResolver } from '../../util/linkResolver';
import { Heading, LazyLink, LazyImage } from '../atoms';

import { styledSection, styledContainer, styledIcon, styledHeading, StyledSubheading } from './PromoBandV2Styles';

const renderHeading = (text, atts) => (
  <Heading {...atts} css={atts.css}>
    {text.text}
  </Heading>
);

const PromoBandV2 = ({ input }) => {
  const {
    background_color,
    heading,
    heading_color,
    subheading_color,
    subheading,
    icon,
    cta_button_link,
    cta_button_text,
  } = input.primary;

  return (
    <BulmaSection
      css={styledSection}
      style={{
        backgroundColor: background_color || '#fff',
      }}
    >
      <BulmaContainer css={styledContainer}>
        {icon && icon.url ? <LazyImage css={styledIcon} src={icon.url} alt={icon.alt || 'icon'} /> : null}
        <div>
          {heading &&
            heading[0].text &&
            renderHeading(heading[0], {
              style: heading_color ? { color: heading_color } : null,
              className: 'h2 darkblue',
              css: styledHeading,
              renderAs: 'h2',
            })}
          {subheading && subheading[0].text && (
            <StyledSubheading styles={{ color: subheading_color || null }}>
              <RichText render={subheading} linkResolver={linkResolver} />
            </StyledSubheading>
          )}
        </div>
        {cta_button_link && cta_button_link.url ? (
          <LazyLink className="button-link is-primary" url={cta_button_link.url}>
            {cta_button_text}
          </LazyLink>
        ) : null}
      </BulmaContainer>
    </BulmaSection>
  );
};

export default PromoBandV2;

PromoBandV2.propTypes = {
  input: PropTypes.object.isRequired,
};
